import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import Radium from 'radium';

import Styles from './ProjectListFooterLink.styles';

class ProjectListFooterLink extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.history.push(this.props.url);
  }

  render() {
    return (
      <div
        role="button"
        tabIndex={-1}
        style={[Styles.linkButton, this.props.style]}
        onClick={this.onClick}
      >
        {this.props.label}
      </div>
    );
  }
}

ProjectListFooterLink.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default withRouter(Radium(ProjectListFooterLink));



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListFooterLink/ProjectListFooterLink.js